<div class="bid-page">
  <button type="button" class="bid-back" (click)="onCancel()">
    <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M12 4l-6 6 6 6"/></svg>
    {{ cargoRequest ? t('ffBid.backToRequest', 'К запросу') + ' ' + requestNo : t('header.searchOrders', 'Поиск запросов') }}
  </button>

  <header class="bid-head">
    <div class="bid-head__meta" *ngIf="cargoRequest as r">
      <span class="bid-head__num">{{ t('ffRequest.title', 'Запрос') }} {{ requestNo }}</span>
      <span class="rate-pill">{{ rateLabel(r.rateType) }}</span>
    </div>
    <h1>{{ isEditMode ? editTitleText : titleText }}</h1>
    <p class="bid-head__sub" *ngIf="cargoRequest as r">
      {{ r.fromCity }} <span aria-hidden="true">→</span> {{ r.toCity }}
    </p>
  </header>

  <div *ngIf="error" class="pp-error bid-error" role="alert">{{ error }}</div>
  <div *ngIf="loading && !cargoRequest" class="pp-card"><div class="pp-loading">{{ loadingText }}</div></div>

  <div class="bid-grid" *ngIf="!loading || cargoRequest">
    <!-- Форма ставки -->
    <form class="pp-card bid-form" [formGroup]="bidForm" (ngSubmit)="onSubmit()" novalidate>
      <section class="bid-section">
        <h2>{{ t('ffBid.offer', 'Ваше предложение') }}</h2>
        <div class="offer-row">
          <div class="pp-field offer-price">
            <label for="price">{{ t('ffBid.price', 'Стоимость перевозки') }}</label>
            <div class="money-input" [class.is-invalid]="invalid('price') || invalid('currencyId')">
              <input id="price" type="number" inputmode="decimal" step="0.01" min="0.01" formControlName="price" placeholder="0" />
              <select formControlName="currencyId" [attr.aria-label]="currencyLabel">
                <option [ngValue]="null" disabled>{{ t('ffBid.currency', 'Валюта') }}</option>
                <option *ngFor="let c of currencies" [ngValue]="c.id">{{ c.code }}</option>
              </select>
            </div>
            <span class="field-error" *ngIf="invalid('price')">{{ t('ffBid.priceError', 'Укажите стоимость больше нуля') }}</span>
            <span class="field-error" *ngIf="!invalid('price') && invalid('currencyId')">{{ t('ffBid.currencyError', 'Выберите валюту') }}</span>
          </div>

          <div class="pp-field offer-days">
            <label for="deliveryDays">{{ t('ffBid.deliveryDays', 'Срок доставки') }}</label>
            <div class="suffix-input" [class.is-invalid]="invalid('deliveryDays')">
              <input id="deliveryDays" type="number" inputmode="numeric" min="1" max="365" formControlName="deliveryDays" placeholder="7" />
              <span>{{ t('ffBid.days', 'дней') }}</span>
            </div>
            <span class="field-error" *ngIf="invalid('deliveryDays')">{{ t('ffBid.daysError', 'От 1 до 365 дней') }}</span>
          </div>
        </div>
      </section>

      <section class="bid-section">
        <h2>
          {{ t('ffBid.services', 'Что входит в ставку') }}
          <small>{{ t('ffBid.servicesHint', 'выберите хотя бы одну услугу') }}</small>
        </h2>
        <div class="services" formArrayName="serviceIds">
          <label *ngFor="let service of services; let i = index" class="service" [class.is-on]="getServiceControl(i).value">
            <input type="checkbox" [formControl]="getServiceControl(i)" />
            <span class="service__box" aria-hidden="true">
              <svg viewBox="0 0 20 20"><path d="M4.5 10.5l3.5 3.5 7.5-8"/></svg>
            </span>
            <span class="service__name">{{ getServiceName(service) }}</span>
          </label>
        </div>
        <span class="field-error" *ngIf="servicesInvalid">{{ t('ffBid.servicesError', 'Выберите хотя бы одну услугу') }}</span>
      </section>

      <section class="bid-section">
        <h2>
          {{ t('ffBid.note', 'Комментарий для клиента') }}
          <small>{{ t('ffBid.optional', 'необязательно') }}</small>
        </h2>
        <textarea class="note" formControlName="note" rows="3"
                  [placeholder]="t('ffBid.notePlaceholder', 'Например: условия оплаты, тип транспорта, что не входит в цену')"></textarea>
      </section>

      <div class="bid-actions">
        <button type="submit" class="pp-btn pp-btn--primary bid-submit" [disabled]="loading">
          {{ loading ? (isEditMode ? updatingText : submittingText) : (isEditMode ? t('ffBid.save', 'Сохранить изменения') : t('ffBid.send', 'Отправить ставку')) }}
        </button>
        <button type="button" class="pp-btn pp-btn--ghost" (click)="onCancel()">{{ cancelText }}</button>
      </div>
    </form>

    <!-- Кратко о запросе -->
    <aside class="pp-card bid-summary" *ngIf="cargoRequest as r">
      <h2>{{ t('ffBid.aboutRequest', 'О запросе') }}</h2>
      <dl>
        <div>
          <dt>{{ t('freightForwarder.requests.loadingDate', 'Дата погрузки') }}</dt>
          <dd>{{ r.loadingDate | date:'dd.MM.yyyy' }}</dd>
        </div>
        <div>
          <dt>{{ t('ffRequest.totalWeight', 'Общий вес') }}</dt>
          <dd>{{ formatWeight(getTotalWeight()) }}</dd>
        </div>
        <div>
          <dt>{{ t('ffRequest.totalVolume', 'Общий объём') }}</dt>
          <dd>{{ formatVolume(getTotalVolume()) }}</dd>
        </div>
        <div>
          <dt>{{ t('ffRequest.totalPlaces', 'Всего мест') }}</dt>
          <dd>{{ placesCount }}</dd>
        </div>
        <div *ngIf="r.price">
          <dt>{{ t('freightForwarder.requests.price', 'Стоимость груза') }}</dt>
          <dd>{{ formatMoney(r.price, currencyCode(r.currencyId)) }}</dd>
        </div>
      </dl>
      <ul class="bid-summary__traits">
        <li *ngFor="let f of cargoTraits" [class.is-warn]="f.warn">{{ f.label }}</li>
      </ul>
    </aside>
  </div>
</div>
